import type { EntryFilters } from './actions'

export const inboxKeys = {
  all: ['inbox'] as const,
  list: (status: string) => [...inboxKeys.all, 'list', status] as const,
  detail: (id: string) => [...inboxKeys.all, 'detail', id] as const,
  counts: () => [...inboxKeys.all, 'counts'] as const,
}

export const entryKeys = {
  all: ['entries'] as const,
  list: (filters: EntryFilters) => [...entryKeys.all, 'list', filters] as const,
  detail: (id: string) => [...entryKeys.all, 'detail', id] as const,
}

export const reviewKeys = {
  all: ['review'] as const,
  daily: () => [...reviewKeys.all, 'daily'] as const,
}

export const summaryKeys = {
  all: ['kb-summary'] as const,
  detail: (date: string) => [...summaryKeys.all, 'detail', date] as const,
}

export const searchKeys = {
  all: ['kb-search'] as const,
  detail: (q: string, limit?: number) => [...searchKeys.all, 'detail', q, limit ?? null] as const,
}

export const messageKeys = {
  all: ['messages'] as const,
  list: (unreadOnly: boolean) => [...messageKeys.all, 'list', unreadOnly] as const,
}

export const statsKey = ['stats'] as const

export const v3Keys = {
  all: ['v3'] as const,
  list: (page: number, pageSize: number) => [...v3Keys.all, 'list', page, pageSize] as const,
  detail: (id: string) => [...v3Keys.all, 'detail', id] as const,
  inbox: (status: string, page: number, pageSize: number) =>
    [...v3Keys.all, 'inbox', status, page, pageSize] as const,
}

export const hardwareKeys = {
  all: ['hardware'] as const,
  projects: () => [...hardwareKeys.all, 'projects'] as const,
  project: (id: string) => [...hardwareKeys.all, 'project', id] as const,
  bom: (projectId: string) => [...hardwareKeys.all, 'bom', projectId] as const,
  prices: () => [...hardwareKeys.all, 'prices'] as const,
}

export const healthKeys = {
  all: ['health'] as const,
  metrics: (query: { metric?: string; start?: string; end?: string } = {}) =>
    [...healthKeys.all, 'metrics', query] as const,
  reports: () => [...healthKeys.all, 'reports'] as const,
  report: (id: string) => [...healthKeys.all, 'report', id] as const,
}

export const financeKeys = {
  overview: ['finance', 'overview'] as const,
  macro: (days: number) => ['finance', 'macro', days] as const,
  macroDashboard: ['macro', 'dashboard'] as const,
  strategy: ['finance', 'strategy'] as const,
  blindProgress: ['finance', 'blind', 'progress'] as const,
  blindCase: (index: number) => ['finance', 'blind', 'case', index] as const,
  activity: ['finance', 'activity'] as const,
  holdings: ['finance', 'holdings'] as const,
  cashflow: ['finance', 'cashflow'] as const,
  v3Prices: (symbol: string, days: number) => ['finance', 'v3', 'prices', symbol, days] as const,
  v3Backtests: ['finance', 'v3', 'backtests'] as const,
  v3BacktestDetail: (id: string) => ['finance', 'v3', 'backtests', id] as const,
}
